module.exports = "/shared/fonts/helvetica-lt-compressed.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/ui/fonts/helvetica-lt-compressed.ttf
// module id = 318
// module chunks = 13